<formly-label-and-validation [label]="to.label" [required]="to.required" [field]="field">
  <ng-select [formControl]="formControl" [clearable]="true">
    <ng-option [value]="''">
      Geen
    </ng-option>
    @for (user of userQueries.all$ | async; track user) {
      <ng-option [value]="user.id">{{
        user.displayName
      }}</ng-option>
    }
  </ng-select>
</formly-label-and-validation>
